import { useState, useCallback } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "./ui/alert-dialog";

// Imperative confirmation dialog. Usage:
//   const { confirm, ConfirmUI } = useConfirm();
//   if (await confirm({ title, description, confirmLabel, variant })) { ... }
//   render {ConfirmUI}
export function useConfirm() {
  const [state, setState] = useState(null);

  const confirm = useCallback(
    (opts) => new Promise((resolve) => setState({ ...opts, resolve })),
    []
  );

  const close = (result) => {
    if (state?.resolve) state.resolve(result);
    setState(null);
  };

  const ConfirmUI = (
    <AlertDialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent className="glass border-white/10" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">{state?.title || "Confermi?"}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">
            {state?.description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            data-testid="confirm-cancel"
            className="bg-white/5 border-white/10 hover:bg-white/10 text-slate-200"
            onClick={() => close(false)}
          >
            Annulla
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-ok"
            onClick={() => close(true)}
            className={
              state?.variant === "danger"
                ? "bg-rose-500 hover:bg-rose-400 text-white"
                : "bg-indigo-500 hover:bg-indigo-400 text-white"
            }
          >
            {state?.confirmLabel || "Conferma"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { confirm, ConfirmUI };
}
